<p class="unsubscribe-message">{{resultText}}</p>
